var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { getPinnedGames } from "../../../../actions/games/creators";
import Loader from "../../../Loader";
import GamesList from "../GamesList";
var messages = defineMessages({
    favorites: {
        id: "games.favorites",
        defaultMessage: "Избранные",
    },
    empty_favorite_games: {
        id: "empty_favorite_games",
        defaultMessage: "У вас нет избранных игр",
    },
});
var GamesPinned = /** @class */ (function (_super) {
    __extends(GamesPinned, _super);
    function GamesPinned() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamesPinned.prototype.render = function () {
        var _a = this.props, data = _a.data, isLoading = _a.isLoading, openGamesLoading = _a.openGamesLoading;
        var pinnedGames = data.Items;
        return (_jsxs("div", { children: [(isLoading || openGamesLoading) && _jsx(Loader, {}), _jsx("div", __assign({ style: {
                        margin: "10px 10px 0px",
                        color: "#fff",
                        padding: "10px 30px",
                        backgroundColor: "gray",
                        width: "fit-content",
                        border: this.props.darkTheme && "1px solid #afafaf",
                    } }, { children: this.props.intl.formatMessage(messages.favorites) })), pinnedGames && !pinnedGames.length && (_jsx("h3", __assign({ style: { padding: "40px", textAlign: "center" } }, { children: this.props.intl.formatMessage(messages.empty_favorite_games) }))), _jsx(GamesList, { fetchData: this.props.getPinnedGamesAction, onlyPinned: true })] }));
    };
    return GamesPinned;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, data = _a.data, isLoading = _a.isLoading;
    var openGamesLoading = state.games.openGame.isLoading;
    return {
        data: data,
        isLoading: isLoading,
        openGamesLoading: openGamesLoading,
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    getPinnedGamesAction: getPinnedGames,
};
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GamesPinned)));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesPinned/GamesPinned.jsx